import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useTranslation } from "@/i18n/translations";

export default function IgStoryReactionsPanel({ API }) {
  const { t } = useTranslation();
  const [salon, setSalon] = useState(null);
  const [ig, setIg] = useState({ story_reaction_enabled: false, story_reaction_info: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/salons`).then((r) => {
      const s = (r.data || [])[0];
      if (!s) return;
      setSalon(s);
      setIg({ story_reaction_enabled: s.story_reaction_enabled === true, story_reaction_info: s.story_reaction_info || "" });
    }).catch(() => {});
  }, [API]);

  const save = async (patch) => {
    if (!salon) return;
    const next = { ...ig, ...patch };
    setIg(next);
    setSaving(true);
    try {
      await axios.put(`${API}/salons/${salon.id}`, next);
      toast.success(t("mk.saved"));
    } catch { toast.error("Error"); }
    setSaving(false);
  };

  return (
    <div className="mt-4 pt-4 border-t border-pink-200" data-testid="mk-ig-block">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div className="flex-1 min-w-[220px]">
          <h4 className="font-bold text-black text-base">🔥 {t("mk.igTitle")}</h4>
          <p className="text-xs text-gray-600">{t("mk.storyReactHint")}</p>
        </div>
        <button type="button" data-testid="story-reaction-toggle" disabled={saving || !salon}
          onClick={() => save({ story_reaction_enabled: !ig.story_reaction_enabled })}
          className={`text-xs font-semibold px-3 py-1.5 rounded-full border-2 shrink-0 transition-colors ${
            ig.story_reaction_enabled ? "border-green-600 bg-green-600 text-white" : "border-gray-400 bg-white text-gray-600"}`}>
          {ig.story_reaction_enabled ? "🟢 Включено" : "⚪ Выключено"}
        </button>
      </div>
      {ig.story_reaction_enabled && (
        <div className="mt-3" data-testid="story-reaction-fields">
          <label className="text-xs font-semibold text-gray-700">{t("mk.storyReactInfo")}</label>
          <textarea data-testid="story-reaction-info-input" rows={2} value={ig.story_reaction_info || ""}
            onChange={(e) => setIg({ ...ig, story_reaction_info: e.target.value })}
            onBlur={() => save({})}
            placeholder={t("mk.storyReactPlaceholder")}
            className="mt-1 w-full border-2 border-gray-200 rounded-xl px-3 py-2 text-sm bg-white focus:border-black outline-none" />
          <p className="text-[11px] text-gray-500 mt-1">{t("mk.storyReactTip")}</p>
        </div>
      )}
    </div>
  );
}
